// extracted by mini-css-extract-plugin
export var info_item = "n_N";
export var info_replies = "n_P";
export var info_replies_title = "n_Q";
export var info_countdown = "n_R";
export var info_date = "n_S";
export var info_time = "n_T";
export var info_btn = "n_V";
export var info_link = "n_W";